import React, { useEffect } from "react";
import { connect } from "react-redux";
import BreadCrumb from "../../components/template/BreadCrumb";
import Header from "../../components/template/Header";
import renderHTML from "react-render-html";
import { getNewsletter } from "../../store/actions/newsletters_action";
import Spinner from "../../components/layout/Spinner";
import SingleItem from "../../components/template/SingleItem";
import { Link } from "react-router-dom";
const ViewNewsletter = ({
  getNewsletter,
  match,
  newsletter: { loading, newsletter },
}) => {
  useEffect(() => {
    getNewsletter(match.params.id);
  }, [match]);
  return (
    <div className="pace-done">
      <div>
        <Header />
        <BreadCrumb
          title="Newsletters"
          mainLinkTitle="Newsletters"
          mainLinkUrl="/newsletters"
          activeLink="View"
        />
        {!loading ? (
          newsletter && (
            <div className="container-fluid">
              <div className="row">
                <div className="col-lg-4">
                  <div className="card">
                    <div className="card-header">
                      <div>
                        <h4 className="card-title">
                          {newsletter.name} <span>View</span>
                        </h4>
                        <p className="card-title-desc">
                          <Link
                            to="/newsletters"
                            className="btn btn-soft-light"
                          >
                            <i className="fa fa-angle-left"></i> Newsletters
                          </Link>
                          <Link
                            to={`/newsletters/${newsletter.id}/edit`}
                            className="btn btn-soft-light"
                          >
                            <i className="fa fa-edit"></i>
                          </Link>
                        </p>
                      </div>
                    </div>
                    <div className="card-body">
                      <SingleItem title="title" value={newsletter.title} />

                      {newsletter.featured_image && (
                        <SingleItem title="Featured Image">
                          <img
                            src={`${newsletter.featured_image}`}
                            style={{
                              width: "100%",
                              height: "200px",
                              objectFit: "contain",
                            }}
                          />
                        </SingleItem>
                      )}
                      {newsletter.gallery && (
                        <SingleItem title="Gallery">
                          {newsletter.gallery.map((pic) => {
                            return (
                              <img
                                src={pic}
                                style={{
                                  width: "100%",
                                  height: "100px",
                                  objectFit: "contain",
                                }}
                              />
                            );
                          })}
                        </SingleItem>
                      )}
                    </div>
                  </div>
                </div>
                <div className="col-md-8">
                  <div className="card">
                    <div className="card-header"> Content </div>
                    <div className="card-body">
                      <div className="card-content">
                        {newsletter.content && renderHTML(newsletter.content)}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          )
        ) : (
          <div>
            <Spinner />
          </div>
        )}
      </div>
    </div>
  );
};

const mapStateToProps = (state) => ({ newsletter: state.newsletter });

const mapDispatchToProps = { getNewsletter };

export default connect(mapStateToProps, mapDispatchToProps)(ViewNewsletter);
